import { Borrower } from './borrower.model';
import { BorrowerFactory } from './borrower.factory';
import { Injectable } from '@angular/core';
import { ModelService } from '../../../shared/services/model.service';
import { ApiHttpClient } from 'app/http/clients/api';

@Injectable()
export class BorrowerService extends ModelService<Borrower> {
    protected urlPath = '/borrower';

    constructor (
        private borrowerFactory: BorrowerFactory,
        http: ApiHttpClient
    ) {
        super(http);
    }

    createFromResponseData(responseData: any): Borrower {
        return this.borrowerFactory.create(responseData);
    }
}
